<template>
  <v-app class="preregistro">
    <v-container class="preregistro-container">
      <v-layout>
        <v-flex xs12 sm10 md8 lg6 class="mx-auto">
          <!-- Banner del evento -->
          <div class="banner-preregistro">
            <img
              v-if="bannerUrl"
              :src="bannerUrl"
              alt="Banner del evento"
              class="imagen-responsive"
            />
            <div v-else class="banner-placeholder">
              <v-icon large>image</v-icon>
              <p class="mb-0">Imagen de referencia del evento (banner o mapa)</p>
            </div>
          </div>

          <v-card class="card-preregistro">
            <div class="titulo-preregistro">
              <span class="titulo-icono">🎟️</span>
              <h1>
                Regístrate y únete a la <span class="titulo-resaltado">preventa</span>
              </h1>
            </div>

            <v-card-text class="pt-2">
              <v-form ref="form_preregistro" @submit.prevent="enviarPreregistro">
                <v-text-field
                  v-model="preregistro.nombre"
                  label="Nombre completo*"
                  :rules="rules.nombre"
                  prepend-inner-icon="perm_identity"
                  autocomplete="name"
                  color="#e8453c"
                  outlined
                  dense
                  required
                ></v-text-field>

                <v-text-field
                  v-model="preregistro.cedula"
                  label="Cédula de Identidad*"
                  :rules="rules.cedula"
                  prepend-inner-icon="assignment_ind"
                  inputmode="numeric"
                  color="#e8453c"
                  outlined
                  dense
                  required
                ></v-text-field>

                <v-text-field
                  v-model="preregistro.telefono"
                  label="Teléfono*"
                  type="tel"
                  :rules="rules.telefono"
                  prepend-inner-icon="phone"
                  autocomplete="tel"
                  color="#e8453c"
                  outlined
                  dense
                  required
                ></v-text-field>

                <v-text-field
                  v-model="preregistro.correo"
                  label="Correo*"
                  type="email"
                  :rules="rules.correo"
                  prepend-inner-icon="email"
                  autocomplete="email"
                  color="#e8453c"
                  outlined
                  dense
                  required
                ></v-text-field>

                <!-- Mapa de puestos del evento -->
                <p class="subtitulo-seccion">Mapa de puestos</p>
                <div class="mapa-puestos mb-4">
                  <img
                    v-if="mapaUrl"
                    :src="mapaUrl"
                    alt="Mapa de puestos del evento"
                    class="imagen-responsive"
                  />
                  <div v-else class="banner-placeholder">
                    <v-icon large>map</v-icon>
                    <p class="mb-0">Imagen del mapa de puestos</p>
                  </div>
                </div>

                <v-select
                  v-model="preregistro.localidad"
                  :items="localidades"
                  label="¿Qué localidad está interesad@?*"
                  :rules="rules.localidad"
                  prepend-inner-icon="event_seat"
                  :menu-props="{ offsetY: true }"
                  color="#e8453c"
                  item-color="#e8453c"
                  outlined
                  dense
                  required
                ></v-select>

                <v-btn
                  type="submit"
                  class="btn-enviar"
                  color="#e8453c"
                  dark
                  block
                  x-large
                  :loading="enviando"
                  :disabled="enviando"
                >
                  Enviar pre registro
                  <v-icon right>send</v-icon>
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import { configApi } from "../../api/configApi";

const ENDPOINT_PREREGISTRO = `${configApi.apiUrl}evento/preregistro`;

export default {
  name: "preregistro",
  data() {
    return {
      bannerUrl: "/images/preregistro/banner-silvestre-dangond.jpg",
      mapaUrl: "/images/preregistro/mapa-puestos-silvestre-dangond.png",
      localidades: [
        "PALCO PATROCINADORES",
        "PALCO EL BAILE DE TODOS",
        "PALCO LLEGO EL PODER",
        "PALCO LAS LOCURAS MIAS",
        "PALCO LA CHIQUITRILLA",
        "ZONA SILVESTRISTA",
        "GRADERIA",
      ],
      enviando: false,
      preregistro: this.preregistroVacio(),
      rules: {
        nombre: [
          (v) => !!v || "El campo nombre es requerido",
          (v) =>
            (v && v.trim().length >= 3) ||
            "El nombre debe tener al menos 3 caracteres",
        ],
        cedula: [
          (v) => !!v || "El campo cédula de identidad es requerido",
          (v) =>
            /^\d{6,12}$/.test(v) ||
            "La cédula de identidad debe tener un formato válido",
        ],
        telefono: [
          (v) => !!v || "El campo teléfono es requerido",
          (v) =>
            /^\d{7,12}$/.test(v) || "El teléfono debe tener un formato válido",
        ],
        correo: [
          (v) => !!v || "El correo es requerido",
          (v) => /.+@.+\..+/.test(v) || "El correo debe tener un formato válido",
        ],
        localidad: [(v) => !!v || "Seleccione una localidad"],
      },
    };
  },
  methods: {
    preregistroVacio() {
      return {
        nombre: "",
        cedula: "",
        telefono: "",
        correo: "",
        localidad: "",
      };
    },

    async enviarPreregistro() {
      if (!this.$refs.form_preregistro.validate()) {
        swal(
          "Errores de validación",
          "Debe diligenciar todos los campos",
          "error"
        );
        return false;
      }

      this.enviando = true;
      try {
        await axios.post(ENDPOINT_PREREGISTRO, {
          ...this.preregistro,
          evento: this.$route.params.evento,
        });
        swal("¡Listo!", "Tu pre registro fue enviado correctamente", "success");
        this.preregistro = this.preregistroVacio();
        this.$refs.form_preregistro.resetValidation();
      } catch (error) {
        const mensaje =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "No fue posible enviar el pre registro, intenta nuevamente";
        swal("Error", mensaje, "error");
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
/* Colores tomados del banner del evento */
.preregistro {
  background: linear-gradient(180deg, #f6f3f1 0%, #fbe3dc 100%) !important;
}

.preregistro-container {
  padding-top: 24px;
  padding-bottom: 32px;
}

.imagen-responsive {
  display: block;
  width: 100%;
  height: auto;
}

.banner-preregistro {
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

.card-preregistro {
  border-radius: 0 0 12px 12px !important;
  overflow: hidden;
}

.titulo-preregistro {
  padding: 20px 16px 8px;
  text-align: center;
  border-top: 4px solid #e8453c;
}

.titulo-icono {
  display: block;
  font-size: 28px;
  line-height: 1;
  margin-bottom: 6px;
}

.titulo-preregistro h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #3d3d3d;
  word-break: normal;
}

.titulo-resaltado {
  color: #e8453c;
}

.subtitulo-seccion {
  margin: 4px 0 8px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #3d3d3d;
}

.mapa-puestos {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eeeeee;
}

.banner-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  padding: 16px;
  background: #eeeeee;
  border: 2px dashed #bdbdbd;
  color: #757575;
  text-align: center;
}

.btn-enviar {
  margin-top: 8px;
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* Celulares: ocupar todo el ancho y aprovechar el espacio */
@media (max-width: 599px) {
  .preregistro-container {
    padding: 0 0 24px;
  }

  .banner-preregistro,
  .card-preregistro {
    border-radius: 0 !important;
  }

  .card-preregistro {
    box-shadow: none !important;
  }

  .titulo-preregistro h1 {
    font-size: 20px;
  }

  .banner-placeholder {
    height: 160px;
  }
}
</style>
